import { Link } from "react-router-dom";
import { ArrowRight, Quote as QuoteIcon } from "lucide-react";
import { Reveal, Eyebrow } from "../components/Reveal";
import { IMAGES, FOUNDER_META } from "../data/content";
import { useContent } from "../context/ContentContext";

export default function Founders() {
  const { content } = useContent();
  return (
    <div data-testid="founders-page">
      <section className="relative py-24 md:py-32">
        <img src={IMAGES.founders} alt="Founders working together" className="absolute inset-0 w-full h-full object-cover" style={{ objectPosition: "50% 22%" }} />
        <div className="absolute inset-0 hero-overlay" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-12">
          <Reveal><Eyebrow>Meet the Founders</Eyebrow></Reveal>
          <Reveal delay={1}>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-700 text-white mt-5 max-w-3xl leading-[1.08] tracking-tight text-balance">
              The father &amp; son behind the Legacy.
            </h1>
          </Reveal>
          <Reveal delay={2}>
            <p className="text-white/85 text-lg mt-6 max-w-2xl leading-relaxed">
              Two generations, one standard. Adrian and David built this company on the belief
              that your name is only as good as the work you leave behind.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-24 md:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-12 space-y-24">
          {content.founders.map((f, i) => {
            const meta = FOUNDER_META[i] || FOUNDER_META[0];
            const Icon = meta.icon;
            return (
            <div key={f.name} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center ${i % 2 ? "lg:[direction:rtl]" : ""}`}>
              <Reveal>
                <div className="relative [direction:ltr]">
                  <img src={meta.img} alt={f.name} className="w-full h-[540px] object-cover rounded-sm" style={{ objectPosition: "50% 12%" }} />
                  <div className="absolute -bottom-5 left-5 bg-gold text-charcoal px-6 py-3 rounded-sm">
                    <span className="font-display text-2xl font-700">{f.name}</span>
                  </div>
                </div>
              </Reveal>
              <div className="[direction:ltr]">
                <Reveal>
                  <span className="inline-flex items-center gap-2 text-emerald font-600 text-sm tracking-[0.15em] uppercase">
                    <Icon className="w-5 h-5" /> {f.role}
                  </span>
                </Reveal>
                <Reveal delay={1}>
                  <h2 className="font-display text-3xl sm:text-4xl font-600 text-charcoal mt-4 mb-6">{f.name}</h2>
                </Reveal>
                <Reveal delay={2}>
                  <div className="relative pl-6 border-l-2 border-gold mb-6">
                    <QuoteIcon className="w-6 h-6 text-gold mb-2" />
                    <p className="font-display text-xl text-charcoal italic leading-snug">"{f.quote}"</p>
                  </div>
                </Reveal>
                <Reveal delay={3}>
                  <p className="text-olive text-lg leading-relaxed">{f.bio}</p>
                </Reveal>
              </div>
            </div>
            );
          })}
        </div>
      </section>

      <section className="bg-charcoal text-white py-20 md:py-24">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <Reveal>
            <h2 className="font-display text-3xl sm:text-4xl font-600 leading-tight">
              Work with a team that takes it personally.
            </h2>
          </Reveal>
          <Reveal delay={1}>
            <Link to="/quote" className="inline-flex items-center gap-2 bg-emerald text-white px-8 py-4 rounded-sm font-600 mt-8 hover:bg-emerald-dark transition-colors" data-testid="founders-quote-btn">
              Request a Quote <ArrowRight className="w-5 h-5" />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
